module.exports = __webpack_public_path__ + "static/img/bids_image.f854bb99.png";